import { MentionsBudgetDynamiques } from '@components/mentions-budget-dynamiques/models';
import { Block } from '@shared/models';

export const mentionsBudgetDynamiquesMock: Block<MentionsBudgetDynamiques> = {
  type: 'mentions-budget-dynamiques',
  data: {},
};
